var app = angular.module("leonardo");

var ReportsUserListFilters = function(
  $scope,
  $controller,
  $timeout,
  $rootScope,
  ReportService,
  SectorRestService,
  AccountUserService,
) {
  
  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersUser;
  $scope.report_type = ReportService.TYPE_USER;

  $scope.group_options.push({ id: 'managed_by', name: 'Managed By' });

  $scope.filters_options = [];

  $scope.initOptions = function() {
    $scope.filters_options = $scope.filters_base.concat([
      {
        id: 'user_name',
        name: 'User Name',
        label: 'User Name Contains',
        inline: false,
        type: 'text',
        placeholder: 'User Name',
        condition: true,
        conflicts: [],
        onSubmit: $scope.display
      },
      {
        id: 'idle',
        name: 'Unauthenticated',
        label: 'Unauthenticated',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'active',
        name: 'User Status',
        label: 'User Status',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All User Status',
        condition: true,
        options: AccountUserService.STATUS_OPTIONS,
        conflicts: []
      },
      {
        id: 'sector',
        name: 'Sector',
        label: 'Sector',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Sectors',
        condition: true,
        service: SectorRestService,
        conflicts: []
      },
      {
        id: 'fields_active',
        name: 'Fields To Show',
        label: 'Fields To Show',
        inline: false,
        type: 'columns',
        placeholder: 'Select Fields',
        condition: true,
        options: ReportService.fieldsReportUser,
        conflicts: []
      }
    ]);
  };

  $scope.initOptions();

  $rootScope.$broadcast('filters-report:initialized');

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_USER);
  }, 100);

};

app.controller('ReportsUserListFilters', [
  '$scope',
  '$controller',
  '$timeout',
  '$rootScope',
  'ReportService',
  'SectorRestService',
  'AccountUserService',
  ReportsUserListFilters
]);
